import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SearchReservationTypes from "../components/SearchReservationTypes";
import useAppSelector from "../hooks/useAppSelector";
import { useDynamicParams } from "../hooks/useDynamicParams";
import { usePathBuilder } from "../hooks/usePathBuilder";
import { activeReservationTypeSelector, reservationTypesSelector } from "../selectors/Selectors";

const SearchReservationTypesPage = () => {
    const navigate = useNavigate();
    const { reservationTypeId } = useDynamicParams();
    const { buildPath } = usePathBuilder();
    const reservationTypes = useAppSelector(reservationTypesSelector);
    const activeReservationType = useSelector(state => activeReservationTypeSelector(state, reservationTypeId));
    const firstVisibleReservationType = reservationTypes.find(rt => rt.visible);

    useEffect(() => {
        if (!activeReservationType && firstVisibleReservationType?.id) {
            navigate(buildPath(firstVisibleReservationType.id), { replace: true });
        }
    }, [activeReservationType, reservationTypes, navigate, firstVisibleReservationType?.id, buildPath]);

    return activeReservationType ? <SearchReservationTypes activeReservationType={activeReservationType} /> : null;
};

export default SearchReservationTypesPage;
